import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useAxios from "../../../hook/useAxios";
import BreadCrumb from "../../Global/BreadCrumb";
import AddVideosForm from "../AddVideos/AddVideosForm";
import Loading from "../../Global/Loading";

const EditHelpVideos = () => {
  const { t } = useTranslation();
  const { id } = useParams<any>();
  const { fetchData, response } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/help_videos/${id}/edit/`,
    "PUT",
    false,
    "",
    true,
    true
  );

  const {
    fetchData: getHelpVideos,
    response: getEditResponse,
    loading,
  } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/help_videos/${id}/edit/`,
    "GET",
    false,
    "",
    true,
    true
  );

  useEffect(() => {
    getHelpVideos({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="parent-container">
      <h1 className="font-semibold text-default-text text-[16px] mt-5">
        {t("Help videos.Edit help video")}
      </h1>
      <BreadCrumb
        breadcrumb={[
          { name: t("Help videos.Tools"), url: "" },
          { name: t("Help videos.Help videos"), url: "/tools/help-videos" },
          { name: t("Help videos.Edit help video"), url: "" },
        ]}
      />
      {loading ? (
        <Loading loading={true} />
      ) : (
        <div className="flex flex-wrap justify-between mt-4">
          <div className=" w-full h-fit lg:w-[49%] sc:w-[611px] bg-white rounded-md p-7 relative">
            <AddVideosForm
              send={fetchData}
              sendResponse={response}
              getInfo={getEditResponse}
              textButton={t("Tree Species.Update")}
            />
          </div>
          <div className="w-full h-fit lg:w-[48%] sc:w-[559px] bg-white rounded-md p-8 mt-4 lg:mt-0">
            <img
              src="/img/Add help video.svg"
              alt="Add scientific name"
              className="mt-4 ml-2 xl:ml-10"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EditHelpVideos;
